import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function googleSignUp() {
  const redirect = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
}

export default function Signup() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    setBusy(true);
    try {
      await register(name, email, password);
      toast.success(`Welcome, ${name}!`);
      navigate("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Signup failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-linen" data-testid="signup-page">
      <div className="flex items-center justify-center p-8 order-2 lg:order-1">
        <div className="w-full max-w-md">
          <Link to="/" className="text-sm text-charcoal/60 hover:text-charcoal" data-testid="back-home-signup">← Home</Link>
          <h1 className="font-display text-4xl mt-6 mb-2 text-charcoal">Start remembering</h1>
          <p className="text-charcoal/70 mb-8">Create your personal celebration assistant.</p>

          <button onClick={googleSignUp} type="button" data-testid="google-signup-btn" className="w-full pill-btn pill-btn-secondary flex items-center justify-center gap-3 mb-4">
            <svg width="18" height="18" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
            Continue with Google
          </button>

          <div className="flex items-center gap-4 my-6 text-charcoal/40 text-sm">
            <div className="h-px bg-warm flex-1" /> or <div className="h-px bg-warm flex-1" />
          </div>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs uppercase tracking-[0.2em] font-semibold text-charcoal/60 mb-2 block">Your name</label>
              <input type="text" required value={name} onChange={(e) => setName(e.target.value)}
                className="w-full rounded-xl bg-white border border-warm px-4 py-3 focus:outline-none focus:border-terracotta focus:ring-1 focus:ring-terracotta"
                data-testid="signup-name" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.2em] font-semibold text-charcoal/60 mb-2 block">Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full rounded-xl bg-white border border-warm px-4 py-3 focus:outline-none focus:border-terracotta focus:ring-1 focus:ring-terracotta"
                data-testid="signup-email" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.2em] font-semibold text-charcoal/60 mb-2 block">Password</label>
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full rounded-xl bg-white border border-warm px-4 py-3 focus:outline-none focus:border-terracotta focus:ring-1 focus:ring-terracotta"
                data-testid="signup-password" placeholder="Min 6 characters" />
            </div>
            <button type="submit" disabled={busy} data-testid="signup-submit"
              className="w-full pill-btn pill-btn-primary mt-2">{busy ? "Creating account..." : "Create account"}</button>
          </form>

          <p className="text-sm text-charcoal/60 text-center mt-6">
            Already have an account? <Link to="/login" className="terracotta font-semibold" data-testid="link-login">Sign in</Link>
          </p>
        </div>
      </div>
      <div className="hidden lg:block relative order-1 lg:order-2">
        <img src="https://images.pexels.com/photos/34781663/pexels-photo-34781663.jpeg?auto=compress&cs=tinysrgb&h=1200" className="w-full h-full object-cover" alt="" />
      </div>
    </div>
  );
}
